export default "__VITE_ASSET__ZyeA7tKn__"